const initHelpCenter = {
  helpCenters: [],
  isFormLoading: false,
};

export const helpCenterReducer = (state = initHelpCenter, action: any) => {
  if (action.type === "SET_HELP_CENTER") {
    return {
      ...state,
      helpCenters: action.value,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  return state;
};
